// src/mocks/data/verticals/index.js
// Resolves the active vertical module based on ?business_type= / sessionStorage.

import { getBusinessTypeFromUrl } from "../vertical";
import * as beauty from "./beauty";
import * as medical_clinic from "./medical_clinic";

const VERTICALS = {
  beauty,
  medical_clinic,
};

const code = getBusinessTypeFromUrl();
export const active = VERTICALS[code] || VERTICALS.beauty;
